import {
  tara_agency_pricing_plans_structure,
  tara_seller_pricing_plans_structure,
} from '../constants/tara_pricing_plans';
import getCurrencySymbol from './getCurrencySymbol';

const convertAPIPackagesToStructure = (apiResponse: any[]): any[] => {
  const allPlans = [
    ...tara_seller_pricing_plans_structure,
    ...tara_agency_pricing_plans_structure,
  ];

  return allPlans.map((plan: any) => {
    const isSeller = plan.role === 'seller';
    const isAgency = plan.role === 'agency';

    // Find monthly and annual plans
    const monthlyPlan = apiResponse.find(
      (item) =>
        item.package_name.toLowerCase().includes(plan.name.toLowerCase()) &&
        item.package_configure?.type === plan.role &&
        item.time_period_type === 'months'
    );

    const annualPlan = apiResponse.find(
      (item) =>
        item.package_name.toLowerCase().includes(plan.name.toLowerCase()) &&
        item.package_configure?.type === plan.role &&
        item.time_period_type === 'years'
    );

    // Token limit is derived from monthly plan
    const monthlyTokens = monthlyPlan?.package_configure?.token_limit ?? 0;
    const tokenLimit =
      typeof monthlyTokens === 'number' ? monthlyTokens / 1000 : 0;

    // Replace token-related feature text
    const updatedFeatures = plan.features.map((feature: any) => {
      if (/token/i.test(feature)) {
        return tokenLimit
          ? feature.toLowerCase().includes('additional')
            ? `Additional ${tokenLimit.toLocaleString()} tokens p/m`
            : `Up to ${tokenLimit.toLocaleString()} tokens p/m`
          : feature;
      }
      return feature;
    });

    const base = {
      ...plan,
      monthly_slug: monthlyPlan?.slug ?? plan.monthly_slug,
      annual_slug: annualPlan?.slug ?? plan.annual_slug,
      currency:
        monthlyPlan?.package_price?.currency ??
        annualPlan?.package_price?.currency ??
        plan.currency,
      monthly_price: monthlyPlan
        ? `${getCurrencySymbol(monthlyPlan.package_price.currency)}${
            monthlyPlan.package_price.price
          }`
        : plan.monthly_price,
      annual_price: annualPlan
        ? `${getCurrencySymbol(annualPlan.package_price.currency)}${
            annualPlan.package_price.price
          }`
        : plan.annual_price,
      monthly_price_number:
        monthlyPlan?.package_price?.price ?? plan.monthly_price_number,
      annual_price_number:
        annualPlan?.package_price?.price ?? plan.annual_price_number,
      features: updatedFeatures,
    };

    // Add per-seat pricing only for agency plans
    if (isAgency) {
      return {
        ...base,
        monthly_per_seat_price: monthlyPlan
          ? `${getCurrencySymbol(monthlyPlan.package_price.currency)}${
              monthlyPlan.package_price.per_seat_price
            }`
          : plan.monthly_per_seat_price,
        monthly_per_seat_price_number:
          monthlyPlan?.package_price?.per_seat_price ??
          plan.monthly_per_seat_price_number,
        annual_per_seat_price: annualPlan
          ? `${getCurrencySymbol(annualPlan.package_price.currency)}${
              annualPlan.package_price.per_seat_price
            }`
          : plan.annual_per_seat_price,
        annual_per_seat_price_number:
          annualPlan?.package_price?.per_seat_price ??
          plan.annual_per_seat_price_number,
      };
    }

    return base;
  });
};

export default convertAPIPackagesToStructure;
